import type { SectionsCashbackComponent } from '@twisto/api-cms'

import { useAdditionalData } from 'homepage/libs/context'
import { useHighlightedText } from 'homepage/libs/hooks'

import { BenefitCard } from './benefit-card'
import * as styles from './cashback.styles'

export const Cashback = ({ title, highlighted }: SectionsCashbackComponent) => {
  const { cashbackData } = useAdditionalData()
  const { before, highlight, after } = useHighlightedText(title, highlighted)

  if (!cashbackData) {
    return null
  }

  const { affiliate_benefits: affiliateBenefits, benefits } = cashbackData

  return (
    <section css={[styles.cashback, styles.container]}>
      <h2>
        {before}
        <span>{highlight}</span>
        {after}
      </h2>

      <div css={styles.wrapper}>
        <div css={styles.benefits}>
          {benefits?.map((benefit) => (
            <BenefitCard key={benefit.name} {...benefit} />
          ))}
        </div>

        <div css={styles.affiliateBenefits}>
          {affiliateBenefits?.map((benefit) => (
            <BenefitCard key={benefit.name} affiliate {...benefit} />
          ))}
        </div>
      </div>
    </section>
  )
}
